import { render, staticRenderFns } from "./EModalVisualizarPDFs.vue?vue&type=template&id=8123472a"
import script from "./EModalVisualizarPDFs.vue?vue&type=script&lang=js"
export * from "./EModalVisualizarPDFs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports